import { useLocation } from "react-router-dom";
import ZetyAI from "./ZetyAI";
import { isAdminPath } from "../admin/adminRoutes";

/**
 * Floating Techizen AI chat bubble on every public page (admin excluded).
 */
export default function ZetyChatFloat() {
  const { pathname } = useLocation();

  if (isAdminPath(pathname)) return null;

  return <ZetyAI variant="bubble" />;
}
